/*=========================================================================================
  File Name: i18nCommon.js
  Description: File đa ngôn ngữ chung
  ----------------------------------------------------------------------------------------
  Project Name: MISA SME Cloud
	Author: NCThanh1
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	Delcaration: 'Declaration',
	TooltipCheckboxMulti: 'Batch execution',
	Question: 'Instructions for handling common errors',
	LinkApp: 'mtaxapp.misa.vn',
	ExtendFeature: 'Extend feature',
	TimerSyncConnectTaxixion: 'Automatically sync later',
	DeleteAllWarning: 'Do you really want to delete all the imported lines?',
	AddDetail: 'Add row',
	DeleteAll: 'Delete all lines',
	Cancel: 'Cancel',
	Save: 'Store',
	Save2: 'Save',
	SavePrint: 'Store and print',
	Print: 'Print',
	Utilize: 'Utilities',
	DisplayAccount: 'Show account',
	SaveClose: 'Store and close',
	Feature: 'Functions',
	Filter: 'Filter',
	FilterTitle: 'Filter',
	Index: 'No.',
	LearnMore: 'Learn more',
	FilterReport: 'Filter report',
	UnFilter: 'Reset',
	AdvanceFilter: 'Advanced filter',
	Export: 'Export',
	View: 'View',
	ViewDetail: 'Read more',
	Replication: 'Duplicate',
	Delete: 'Delete',
	ChooseReport: 'Select report',
	FromDate: 'From',
	ToDate: 'To',
	FromMonth: 'From month',
	ToMonth: 'To month',
	FromQuarter: 'From quarter',
	ToQuarter: 'To quarter',
	FromYear: 'From year',
	ToYear: 'To year',
	UploadXml: 'Upload XML file',
	Agree: 'Agree',
	Implement: 'Implement',
	Total: 'Total',
	Add: 'Add',
	Finish: 'Finish',
	Back: 'Revert',
	SaveAdd: 'Store and add',
	From: 'From',
	To: 'To',
	to: 'to',
	Become: 'Become',
	Edit: 'Edit',
	ClearCondition: 'Delete conditions',
	Report: 'Report',
	Account: 'Account',
	Choose: 'Select',
	DeleteTrash: 'Delete',
	ReportSpam: 'Report spam',
	NotSpam: 'Not spam',
	Use: 'Usage',
	StopUsing: 'Discontinue use',
	Menu: 'All categories',
	CollapseTooltip: 'Show less',
	ExpandTooltip: 'Extended',
	Term: 'Period',
	Yes: 'Yes',
	No: 'No',
	Show: 'Yes, show',
	NotShow: 'Not display',
	Close: 'Close',
	Help: 'Help',
	RecentView: 'Your recently viewed',
	Description: 'Description',
	Noted: 'Note',
	NotedMany: 'Batch Notes',
	ClosePop: 'Cancel',
	Search: 'Search',
	SearchDot: 'Search…',
	Here: 'In here',
	SeeHere: 'See here',
	All: 'All',
	NoInformation: 'No information',
	Times: 'Time',
	Status: 'Status',
	Branch: 'Branch',
	Of: 'of',
	NotFound: 'Not found.',
	Procedure: 'Procedure',
	UnderConstruction: 'In-progress developments',
	SearchFor: 'Search for',
	Value: 'Value',
	UpdateStatus: 'Update status',
	Update: 'Update',
	And: 'And',
	Or: 'Or',
	Contain: 'Contains',
	NotContain: "Doesn't contain",
	StartsWith: 'starts with',
	EndsWith: 'ends with',
	ClearFilter: 'Clear filter',
	ChooseFilterCondition: 'Select filter condition',
	ShowMore: 'Read more',
	ShowLess: 'Show less',
	Refresh: 'Reload',
	RePrint: 'Print Again',
	Detail: 'Details',
	EnterKeySearch: 'Search keyword',
	Empty: 'Empty',
	NotEmpty: 'Not empty',
	Equal: 'Equal',
	TotalSum: 'Total',
	AddTaxPaper: 'Submit payment form',
	Draft: 'Save draft',
	Next: 'Next',
	Input: 'Enter text',
	CancelRequest: 'An error occurred during processing',
	Date: 'Date',
	Month: 'Month',
	Year: 'Year',
	Quarter: 'Quarter',
	Stage: 'Period',
	TypeTaxPeriod: 'Tax period',
	ChangePopupClose: 'Data has not been saved.</br> Are you sure you want to cancel?',
	CreatedDate: 'Submission date',
	noData: 'No records available',
	SaveDraftSuccess: 'Draft saved successfully',
	BackHome: 'Go to home',
	Unauthorized: 'You have not accessed right',
	ConfigLayout: 'Table settings',
	ConfigColumn: 'Column list displays',
	NoDataFilter: 'No results have been found',
	NoOrganization: 'No organization found',
	ErrorCertificate:
		'The digital certificate is incorrect. You must use the digital certificate registered to use the electronic tax payment service to sign.',
	ErrorFormal: 'Something went wrong. Please check again.',
	CheckAgain: 'Recheck',
	UpdateCostType: 'Update cost norms',
	AcceptResultNote1: 'The program only picks up acceptable and authorized criteria.',
	AcceptResultNote2: 'Select the criteria you want to accept as valid and click "Agree".',
	AcceptResultCol1: 'Criteria name',
	AcceptResultCol2: 'Impact on test results',
	AcceptCheckingResult: 'Valid acceptance',
	PrintCheckingResult: 'Print checking result',
	Download: 'Download',
	ReSubmit: 'Resubmit',
	ViewNotification: 'View announcement',
	OnCapsLock: 'Enabling caps lock',
	NoFilterData: 'No data found',
	GetInfo: 'Getting information',
	NotAuthorized: 'You do not have permission to perform this feature!',
	PageNotFound: '404 Not found',
	InternalServer: 'An error occurred during processing',
	SignIn: 'Login',
	Code: 'Code',
	Name: 'Name',
	NameTaxAgentControl: 'Name of in-charge Tax Authority',
	NameTaxAgentPayer: 'Name of collecting authority',
	BuyNow: 'Buy now',
	BuyMore: 'Additional purchase',
	Accept: 'Confirm',
	CompanyMisa: 'Misa Joint stock company',
	BankACB: 'Head office of Asia Commercial joint stock bank',
	ClickToCopy: 'Press to copy',
	Inactive: 'Discontinue operations',
	Active: 'Active',
	Forward: 'Forward',
	SendMail: 'Send mail',
	Restore: 'Restore',
	AcceptInvoice: 'Approve',
	RejectInvoice: 'Disapprove',
	SendMailSeller: 'Send feedback to supplier',
	SendMailMisa: 'Send to MISA',
	DeleteForever: 'Delete permanently',
	InputSearch: 'Enter to search',
	Default: 'Default',
	RestoreDefaults: 'Restore defaults',
	RestoreFilterDefaults: 'Default filter',
	AddNewStick: 'Create a new label',
	AddNewStick2: 'Add labels',
	Upload: 'Upload',
	Send: 'Submit',
	Connect: 'Connect',
	DisConnect: 'Disconnect',
	ConnectNow: 'Connect now',
	EnterInvoice: 'Enter invoice data',
	UploadExtensionSupport: 'xml,inv,pdf,rar,zip,tar,gzip,7z,jpg,jpeg,jfif,pjpeg,pjp,png,apng,gif,bmp,avif,svg|webp',
	UploadExtensionAccept:
		'.xml,.inv,.pdf,.rar,.zip,.tar,.gzip,.7z,.jpg,.jpeg,.jfif,.pjpeg,.pjp,.png,.apng,.gif,.bmp,.avif,.svg,.webp',
	Accounted: 'Mark as accounted',
	UnAccounted: 'Mark as unaccounted',
	MaxLengthFileUpload: 'The upload capacity should not exceed 5Mb',
	MaxLengthAllFileUpload:
		'The file size should not exceed 5MB for each and the total storage should not exceed 10MB.',
	Notice: 'Note',
	FileSizeTooLarge: 'File size is too large',
	ExistEmail: 'Email already exists',
	MoveInvoice: 'Transfer',
	MoveReceipt: 'Transfer',
	MoveDeclaration: 'Transfer',
	NotSure: 'Checking',
	Replace: 'Replace',
	AttachFile: 'Add file attachment',
	PaymentInvoice: 'Mark as paid',
	MoveOutInvoice: 'Transfer',
	UploadOutInvoiceExtensionSupport: 'xml,inv,rar,zip,tar,gzip,7z',
	UploadOutInvoiceExtensionAccept: '.xml,.inv,.rar,.zip,.tar,.gzip,.7z',
	UploadDeclarationExtensionSupport: 'xml,inv,rar,zip,tar,gzip,7z,xls,xlsx',
	UploadDeclarationExtensionAccept: '.xml,.inv,.rar,.zip,.tar,.gzip,.7z,.xls,.xlsx',
	NoOrgSetting: 'No branches/departments selected',
	NoSupplier: 'No suppliers selected',
	NoEmailSupplier: 'No email, suppliers',
	Success: 'Success',
	Process: 'Processing...',
	ErrorNeedContaxMisa: 'An error has occurred. Please contact MISA for assistance',
	ErrorOccurred: 'An error occurred. Please connect later or contact MISA for support.',
	ErrorProcessNeedContactMisa: 'An error occurred during processing. Please contact MISA',
	InTotal: 'out of',
	DownloadAll: 'Download all',
	Company: 'Company',
	Department: 'Department',
	SystemPendingToCheck: 'The program is checking and will return the results in a few minutes',
	SystemSyncAgain: 'The system is resynchronizing and will return the results in a few minutes',
	InvoiceNo: 'Invoice No.',
	ReceiptNo: 'Receipt No.',
	InvoiceTemplateNo: 'Form No.',
	SymbolInvoice: 'Serial',
	AlertHaveSomeWrongAfterCheckInvoice:
		'After checking the invoice, we found that the following information is incorrect. We would like to be reconsidered by your Company',
	Goodbye: 'Best regards',
	Dear: 'Dear',
	ErrorCannotReadInvoiceFromEmail:
		'Currently, the system has not processed invoice from this email. Please download XML Invoice to check directly',
	DeleteSuccess: 'Deleted successfully',
	RestoreSuccess: 'Restore successfully ',
	SystemDisplayDataToShow: {
		TextStart: 'Program display',
		TextEnd: 'results help to check the data'
	},
	WrongExtension: 'Wrong format',
	Error: 'Error',
	Giude: 'Help',
	ForwardMail: 'Forward email',
	Col: 'Column',
	AddSuccess: 'Add successfully',
	ErrorNeedContactMisa: 'An error has occurred. Please contact MISA for assistance',
	MISAError: 'An error occurred during processing. Please contact MISA for assistance',
	MISAError1: 'An error has occurred. Please contact MISA for assistance',
	TaxCode: 'Tax Code',
	TaxCodeAndIdentification: 'Tax Code/Identification number',
	TaxCodeOrIdentification: 'Tax Code or Identification number',
	PlaceHolderSearchInfo: 'Enter tax code/identification number to search',
	PlaceHolderTaxCodeSearch: 'Enter the tax code to search',
	CompanyName: 'Company name',
	CompanyNameV2: 'Name',
	IdentificationNumber: 'Personal identification number',
	CreateAccounting: 'Prepare document',
	AttachStick: 'Labeling',
	FileAttach: 'Attachments',
	PrintReceipt: 'Print receipt',
	PrintInvoice: 'Print invoice',
	PrintDeclaration: 'Print declaration',
	invoice: 'invoice',
	receipt: 'receipt',
	Invoice: 'Invoice',
	Receipt: 'Receipt',
	ConfirmAccept: 'Do you want to accept it all the next time?',
	UpdateSuccess: 'Update successfully',
	KCT: 'tax KCT',
	KKKNT: 'tax KKKNT',
	CTTC: 'tax CTTC',
	KTPVDC: 'tax KTPVDC',
	KTGTT: 'tax KTGTT',
	Rate0: 'tax 0%',
	Rate5: 'tax 5%',
	Rate8: 'tax 8%',
	Rate10: 'tax 10%',
	RateOther: 'tax others',
	AddAndCheck: 'Add & check',
	SaveAndCheck: 'Save & check  ',
	LimitCapacityFileAttach: 'The program only supports attachments smaller than 5MB',
	ConfirmDeleteFileAttach: 'Are you sure you want to delete this attachment?',
	DeleteFileAttach: 'Delete this attachment',
	DeleteFileAttachSuccess: 'Delete attachment successfully',
	DownloadFileAttachSuccess: 'Download attachment successfully',
	SelectTemplateInvoice: 'Select invoice template',
	Seller: 'Seller',
	SellerName: 'Unit name',
	OrganizationOrPayerName: 'Organization or payer name',
	SellerAddress: 'Address',
	Address: 'Address',
	BuyerName: 'Buyer unit',
	TemplateNo: 'Form No.',
	Series: 'Serial',
	NumberInvoice: 'No.',
	InvoiceDate: 'Invoice date',
	ReceiptDate: 'Receipt date',
	StatementNo: 'Statement no.',
	StatementDate: 'Statement date',
	LimitPeriod: 'Period limit',
	IncorrectInvoiceDate: 'Incorrect invoice date',
	AccountingDate: 'Date of accounting',
	RefNo: 'Ref no.',
	Accountor: 'Accountant',
	Supplier: 'Supplier',
	Item: 'Goods/services',
	BeforeTotalAmount: 'Total amount excluded VAT',
	VatAmount: 'VAT amount',
	TotalAmount: 'Total amount',
	TotalAmountSumary: 'Total amount',
	Warning: 'Warning',
	EmailReceive: 'Invoice receiving email',
	NoInvoice: 'Invoice No.',
	InvoiceNoted: 'Invoice already has a note',
	SaveNoteSuccess: 'Note saved successfully',
	ConditionSaveNoted: 'Please select at least one invoice to note',
	SuggestionsProblem: 'Tell me about your problem',
	BuyerInfo: 'Buyer information',
	SellerInfo: 'Seller information',
	Signature: 'E-Signatures',
	SellerStatus: 'Seller activity status',
	RiskStatus: 'Tax risk status',
	NotiPublishInvoice: 'Issued annoucement invoice',
	Other: 'Other',
	SuggestionsInfoFeedback: 'Please select the information to send feedback',
	SendFeedbackForDevelopmentSuccess: 'Send feedback to the developer successfully',
	ConfirmRemoveStick: 'You are sure you want to remove the selected labels',
	SelectAll: 'Select all',
	RemoveSelectAll: 'Deselect all',
	Selected: 'Selected',
	ClearSelection: 'Unselected',
	ForwardInvoiceSuccess: 'Invoice/receipt successfully transferred',
	ForwardDeclarationSuccess: 'Transfer declaration successfully',
	TotalNeedPayment: 'Total amount to be paid',
	SelectPaymentDate: 'Choose payment date',
	PaymentDate: 'Payment date',
	Payer: 'Payer',
	AmountPayment: 'Payment amount',
	AmountNotPayment: 'Total amount not paid yet',
	PaymentFull: 'Full payment',
	PaymentPartial: 'Partial payment',
	PaymentNextDayPre: 'Date of the next payment',
	PaymentNextDay: 'Date of the next payment',
	Sended: 'Sent',
	ExpressionInvoiceXML: 'This is a viewer based on the XML content of the invoice.',
	ExpressionInvoiceXMLNoted: 'This content may not be correct according to the form of the issued invoice',
	ItemDetail: {
		ItemName: 'Item name',
		UNITNAME: 'Unit',
		Quantity: 'Quantity',
		UnitPrice: 'Unit price',
		DiscountRate: 'Discount rate',
		DiscountRateFull: 'Discount rate',
		DiscountAmount: 'Discount amount',
		AmountWithoutVat: 'Total amount excluded VAT',
		VatRate: 'Tax rate',
		VatAmount: 'Amount of tax',
		Amount: 'Total amount'
	},
	WarningInfo: {
		WarningExpired: 'Expiration alerts',
		LicenseExpired: 'Your resource has expired',
		CheckAgain: 'Errors have been highlighted below.',
		WarningExpriedQuantityInvoice: 'Out of usage invoice warning',
		OutOfQuantityInvoice: 'You have run out of usage invoices',
		WarningDuplicareInvoice: 'Invoice duplicate warning',
		InvoiceNoDuplicate: 'Duplicate invoice no.',
		DeclarationNoDuplicate: 'Duplicate Declaration Number'
	},
	MISAInvoiceBot: 'MISA meInvoice - Processing invoices',
	SaveTime80Per: 'Save 80% hours',
	AutoSearchAnalyze: 'Automatically look up, analyze and check invoices',
	StoreManage: 'Centralized invoice storage and management',
	SyncAppAccounting: 'Synchronization with accounting software and accounting',
	UseFullFeature: 'To use the full features, please',
	InfoForSupport: 'or leave information for further advice',
	FullName: 'Full name',
	PhoneNumber: 'Phone number',
	InputResultEmail: 'Enter email to receive invoice checking results',
	ReceiveResult: 'Receive results',
	UnSendCheckingResultContactMISA: 'Sending invoice  checking result failed. Please contact MISA for assistance',
	OptionOfYou: 'Your opinion',
	ConditionNPS: 'You need to score your satisfaction before sending feedback',
	CopySuccess: 'Copy successfully',
	NotificationSendMail: email => `Invoice sent to email <span style="color: #00aab7">${email}</span> of your Company`,
	ReasonNPS: {
		ReasonNPS1: 'The product does not meet the demand',
		ReasonNPS2: 'The product is often defective',
		ReasonNPS3: 'Customer support consulting service is poor',
		ReasonNPS4: 'Price is high',
		ReasonNPS5: 'Processing speed is slow',
		ReasonNPS6: 'Processing speed is slow',
		ReasonNPS7: 'The operation is not convenient',
		ReasonNPS8: 'Other reason'
	},
	ApplicationProcessing: 'The system is processing and will return the results in a few minutes',
	Change: 'Change',
	Customer: 'Customer',
	ContactMisaUpdateLatest:
		'Please make a connection for MISA to help you automatically update your invoice as quickly as possible',
	InputCustomerNameAndInvoiceNo: 'Enter customer name, invoice no. to search',
	InputSupplierNameAndInvoiceNo: 'Enter supplier name, invoice no. to search',
	InputSupplierNameInvoiceNoAccount: 'Enter supplier name, invoice no. and account to search',
	ErrorTryAgain: 'An error occurred. Please retry',
	TwoFactorAuthentication: 'Two factors authentication',
	ReceiveAuthenticationCode: 'Get an authentication code from the app',
	SettingInDevice: 'that you have installed on your device',
	AuthenticationCodeSend: 'Authentication code has been sent to',
	phonenumber: 'Phone number',
	phone: 'telephone',
	CheckPlease: 'Please check',
	InputAuthenticationCode: 'and enter the correct code in the box below',
	AuthenticationCode: 'Authentication code',
	NotQuestionDevice: 'Do not ask again for this device',
	TryAnotherWay: 'Try another way',
	TryReceiveAuthenticationCodeOther: 'Try getting a different authentication code',
	ReceiveAuthenticationCodeByEmail: 'Receive an authentication code via email',
	ReceiveAuthenticationCodeByPhoneNumber: 'Get an authentication code by phone number',
	YouSetting: 'that you have set up',
	SendAgainAuthenticationCodeSuccess: 'Resend authentication code successfully',
	ApplicationNotAutoDownloadMeinvoice: 'The system does not automatically download invoices issued by',
	ForSaveLicense: 'to save resources',
	DownloadAllInvoiceInbotOfMeInvoice:
		'Load full invoice output<br/> (including the invoices issued by <b>MISA meInvoice</b>)',
	AmisAccounting: 'AMIS Accounting',
	Skip: 'Skip',
	Continue: 'Continue',
	Understood: 'Got it',
	AddSupplierNew: 'Add new supplier',
	ToDay: 'Today',
	InvoiceDownloadSuccess: 'Invoice loaded successfully',
	DeclarationUploadSuccess: 'Declaration uploaded successfully',
	MonthInfo: {
		January: 'January',
		February: 'February',
		March: 'March',
		April: 'April',
		May: 'May',
		June: 'June',
		July: 'July',
		August: 'August',
		September: 'September',
		October: 'October',
		November: 'November',
		December: 'December'
	},
	WeekDays: {
		Monday: 'Mo',
		Tuesday: 'Tu',
		Wednesday: 'We',
		Thursday: 'Th',
		Friday: 'Fr',
		Saturday: 'Sa',
		Sunday: 'Su'
	},
	conditionmin: 'must be less than',
	conditionmax: 'must be greater than',
	notinputempty: 'name must not be left blank',
	AlertPresentationXML: isReceipt =>
		`This is a viewer based on the XML content of the ${isReceipt ? 'receipt' : 'invoice'}.`,
	AlertContentMaybeDifferentInvoice: isReceipt =>
		`This content may not be correct according to the form of the issued ${isReceipt ? 'receipt' : 'invoice'}.`,
	New: 'New',
	Activity: 'Activities',
	SelectLimitOneYear: 'Only a maximum of 1 year is allowed',
	SelectLimitYears: year => `Only a maximum of ${year} years is allowed`,
	SelectLimitDays: number => `Only a maximum of ${number} days is allowed`,
	EachInvoiceWillSpendCost:
		'Each synchronous output invoice will be subtracted from the same resources as the input invoice.',
	FileXmlUploadInValidateTitle: 'Uploaded invoice is invalid',
	FileXmlUploadInValidate:
		"Uploaded seller's tax code - Form No./Serial - invoice no. on *xml file, *inv is different from invoice information which existed in the program.",
	FileXmlUploadFail: 'XML invoice file uploaded fail',
	UploadFileXmlSuccess: 'Uploaded XML file successfully',
	SocialistRepublicVietnam: 'SOCIALIST REPUBLIC OF VIETNAM',
	IndependentFreedomHappy: 'Independence - Freedom - Happiness',
	FileXmlUploadInvalidateFormat: 'Uploaded file has incorrect format invoice (*xml, *inv) ',
	FilePdfUploadInvalidateFormat:
		'Uploaded file has incorrect format invoice (*pdf, *jpg, *jpeg, *jfif, *pjpeg, *pjp, *png, *apng, *gif, *bmp, *avif, *svg, *webp)',
	record: 'record',
	NextPage: 'Next',
	PreviousPage: 'Previous',
	OrderNumber: 'No.',
	million: 'million',
	thousand: 'thousand',
	billion: 'billion',
	trillion: 'trillion',
	quadrillion: 'quadrillion',
	When: 'When',
	Notification: 'Notification',
	MultipleDecentralization: 'Bulk permission',
	Day: 'Day',
	InputInvoice: 'Input invoice',
	OutputInvoice: 'Output invoice',
	supplier: 'supplier',
	ExistedNote: 'note already exist',
	Uploaded: 'Uploaded',
	at: 'at',
	UnPaymentInvoice: 'Unmark as paid',
	Content: 'Content',
	StartDate: 'Start date',
	EndDate: 'End date',
	SearchInvoice: 'Search',
	SearchingInvoice: 'Searching invoice',
	ErrorWarningCaptcha: 'An error occurred during connection, please try reconnecting',
	conditionminorequal: 'must be less than or equal',
	conditionmaxorequal: 'must be greater or equal',
	Option: 'Option',
	Custom: 'Custom',
	Infomation: 'Infomation',
	DefaultTemplate: 'Default template',
	ShortForm: 'Shortened template',
	NotData: 'No data',
	ViewGuide: 'View guide',
	MarkViewed: 'Mark as viewed',
	MarkUnViewed: 'Mark as unviewed',
	NotTaxCodeForSearch: 'There is no seller tax code information to look up',
	NotFindRelaticeInvoice: 'No related invoices were found in the system',
	ViewInfo: 'View information',
	HiddenInfo: 'Hidden information',
	NumberDateNotifyValidate: 'Due date cannot be left blank',
	FeatureUnderDevelop: 'Feature under development.',
	ExperienceNow: 'Experience Now',
	AIAssistantMISA: 'MISA AVA Digital Assistant',
	ViewCriteriaExplain: 'Explain',
	MISARelease: `MISA meInvoice <span style="color: #00aab7">launched</span>`,
	AIFeatureRelease: `<span class="font-bold">MISA AVA</span> on MISA meInvoice can:`,
	HelpToUse: 'Help, instructions for using the software',
	MonitorAndReport: 'Monitor, provide data, quick reports',
	NaturalCommunication: 'Natural communication thanks to GPT Chat application',
	FeatureCommingSoon: '...And many more great features are continuing to be updated',
	AcceptTaxRates: 'Accept tax rates',
	ExceedingLineLimit: 'Exceeding the allowed line limit',
	Translate: 'Translate',
	ConnectUnAuthority: userName =>
		`The account ${userName} does not have permission to look up invoices on the Tax Authority's system.`,
	NotPermissionAcceptResult:
		"You do not have permission to accept invoice's result. Please contact an administrator for authorization.",
	NotPermissionTitle: 'No valid acceptance',
	CheckWidthTCT: 'Check with Tax Authority',
	Undefined: 'Undefined',
	UndefinedStatus: isApplyNewLogic =>
		`Seller's operating status at ${!isApplyNewLogic ? 'invoice date' : 'check date'}  is unknown`,
	SellerActive: date => `Seller is active on ${date}`,
	SellerInactive: date => `Seller is inactive on ${date}`,
	SellerUndifinedStatus: date => `Seller's operating status is unknown on ${date}`,
	SellerStatusDetail: (text, date) => `Seller's operating status ${text} on ${date}`,
	SellerWaitingUpdateIdentityCode: date => `Seller's waiting for identification number update on ${date}`, //translate to english
	WaitingVerification: date => `Seller's operating status waiting for verification on ${date}`,
	InvalidCaptcha: 'There is a system error. Please reconnect or contact MISA for support.',
	PermissionGuild: 'Instructions for granting permission',
	TypeOfUploadInvoice: 'Ways to upload invoices to the software',
	TypeOfUploadInvoiceThirdParty: 'Ways to upload invoices to the software',
	UpLoadFileInvoice: 'Upload available invoice files (*xml, *inv, *pdf)',
	SendEmail: email => `Send or forward electronic invoices to email <span style="cursor: pointer;color: #00A2CF">${email}</span>`,
	ConnectCQT:
		'Connect with <span style="color: #DC6803;font-weight: 700;">Tax Authority</span> to automatically download invoices',
	ConnectNCC: 'Connect with suppliers to automatically download invoices',
	BtnConnectCQT: 'Connect Tax Authority',
	BtnConnectNCC: 'Connect Suppliers',
	BtnSendEmail: 'Send email',
	TypeOfUploadOutInvoice: 'Ways to upload outinvoices to the software:',
	UploadFileOutInvoice: 'Upload available outinvoice files (*xml, *inv)',
	PopularQuestion: 'Common questions',
	MinusResourceInvoice:
		'<b>Note:</b> For each output invoice entered into the program, you will <b>be deducted resources</b>.',
	MinusResourceDeclaraiton:
		'<b>Note:</b> For each declaration entered into the program, you will <b>be deducted resources</b>.',
	UploadDeclaration: 'Upload available declaration files (*xls, *xlsx, *xml)',
	TypeOfUploadDeclaration: 'Ways to upload declarations to the software:',
	ClickTo: 'Click to',
	checkAgain: 'check again',
	Click: 'Click',
	toCheckAgain: 'to check again',
	InvalidDateNoDownload: date => `Please select a time after date ${date} with status Not loaded yet.`,
	AcceptText: 'Accept',
	Explain: 'Explain',
	HelpfulReview: 'Helpfull review',
	NotHelpfulReview: 'Not helpfull review',
	ViewFilmInstruction: 'Watch the video tutorial',
	SettingConnectTax: 'Setting up connection with the tax authority',
	VND: 'Currency: Dong Viet Nam',
	TourguideCostType:
		'You need to set up Time Costing before viewing the report. Please go to <b>System/Options</b> to set up Time Costing.',
	ContaxWithMisa: 'An error occurred, please contact MISA for assistance.',
	LookupCQT: 'Data is continuously searched and updated from many sources such as the Tax Authority.',
	UpdateDBHC: 'Update administrative boundaries',
	UpdateDBHCDetail:
		'The results of checking the buyer and seller addresses on a series of invoices may be affected by the arrangement of administrative boundaries at the District and Commune levels according to Resolution No. 35/2023/UBTVQH15.',
	ViewGuideDetail: 'View the detail guide',
	NotRestoreDeclaration: 'You cannot restore the declaration.',
	StatusInvoiceNew: 'new invoice',
	StatusInvoiceAdjusted: 'adjusted invoice',
	StatusInvoiceReplaced: 'replaced invoice',
	ContinueSave: 'Continue to save',

	// BỔ SUNG: Keys cho combobox view info
	ViewAllInvoices: 'View all invoices',
	ViewSelectedInvoices: 'View selected invoices only',
	InvalidTaxCode: 'Tax code is not in the correct format. Please check again.',
	SetupNow: 'Set up now',
	CannotFindData: 'No data found according to filter conditions',
	FilterAgain: 'Please try selecting the filter conditions again to find your data',
	FilterUserSettingAgain: 'No user information found according to search conditions, please try again',
	FilterLayoutAgain: 'No column found according to search conditions, please try again',
	SelectAtleastCretial: 'Please select at least one criterion before clicking <strong>Agree</strong>',
	NoServiceProviderFound: 'Not found suppliers of goods or services.',
	NoLicenseInfo: 'Please purchase a subscription to use MISA meInvoice - Processing invoices',
	DownloadFileError: 'A system error has occurred, please try again later.',
	NoSubscriber: 'Failed to get organization information, please try again later.',
	pagingText: 'Rows/page',
	ProcessingResult: 'Processing results',
	FieldName: 'Field name',
	ApplyText: 'Apply',

	// Keys for exit without saving confirm
	ExitConfirmTitle: 'Do you want to exit without saving?',
	ExitConfirmContent: 'If you exit, the entered data will not be saved.',
	StayOnForm: 'Stay',
	ExitWithoutSaving: 'Exit without saving',
	NoPermissionTitle: 'No permission to perform function',
	NoPermissionFunctionTitle: 'No permission to perform this action',
	NoPermissionPartTitle: 'No permission',
	NoPermissionContactAdmin: 'Please contact an administrator to resolve this issue.',
	NoPermissionSyncInput: 'You do not have permission to sync input invoices. Please <b>uncheck "Input invoices"</b> to continue.<br/>To get full invoice sync permissions, please contact an administrator to resolve this issue.',
	NoPermissionSyncOutput: 'You do not have permission to sync output invoices. Please <b>uncheck "Output invoices"</b> to continue.<br/>To get full invoice sync permissions, please contact an administrator to resolve this issue.',
	SelectFile: 'Select file'
};